/**
 * Number of policies by whether one of the Policy Holders is the Insured Person
 */
import get from "lodash.get"

export default payload => {
	const workSheetData = [...header, ...rows(payload)]
	const workSheetColumns = header[1].map(item => {
		return { wpx: 200 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		},
		{
			s: { r: 2, c: 0 },
			e: { r: 11, c: 0 }
		},
		{
			s: { r: 12, c: 0 },
			e: { r: 21, c: 0 }
		}
	]

	return { workSheetData, workSheetColumns, workSheetMerges }
}

const header = [
	[
		"Template 10 - Number of policies by whether one of the Policy Holders is the Insured Person"
	],
	[
		"",
		"Number of Policy Holders",
		"Number of Standard Plan Policies",
		"Number of Flexi Plan Policies"
	]
]
const rows = payload => {
	let output = []
	for (let i = 1; i <= 20; i++) {
		if (i >= 11) {
			output.push([
				"No Policy Holder is the insured Person",
				i - 10,
				checkIfNoHolderIsInsured(payload, i - 10),
				0
			])
		} else {
			output.push([
				"At least one Policy Holder is insured person",
				i,
				checkIfOneHolderIsInsured(payload, i),
				0
			])
		}
	}
	return output
}

/**
 * @description
 * returns count of Policy Holders that are not the Insured Person
 * @param {*} payload
 * @param {*} numberOfPolicyHolders
 */

const checkIfOneHolderIsInsured = (payload, numberOfPolicyHolders) => {
	return payload.filter(policy => {
		// Name of Primary Holder
		const holderName = get(policy, "contractHolder.name")
		// Name of Insured Person
		const insuredName = get(policy, "contractInsured[0].name")
		// Array of Other Holders
		const otherHoldersArray = get(policy, "otherContractHolders", [])
		// Array of Primary Holder Name and Other Holders Names
		let allHolderNamesArray = [holderName]
		if (otherHoldersArray) {
			allHolderNamesArray.push(otherHoldersArray.map(item => item.name))
		}

		// Sum of Other holder(s) + Primary Holder
		const totalPolicyHolders =
			otherHoldersArray !== null ? otherHoldersArray.length + 1 : 0

		// Check whether one of Policy holders is Insured Person
		let hasEqual = null
		allHolderNamesArray.filter(item => {
			if (insuredName === item) hasEqual = true
		})

		if (
			policy.status === "ISSUED" &&
			totalPolicyHolders === numberOfPolicyHolders &&
			hasEqual === true
		) {
			return policy
		}
	}).length
}
const checkIfNoHolderIsInsured = (payload, numberOfPolicyHolders) => {
	return payload.filter(policy => {
		// Name of Primary Holder
		const holderName = get(policy, "contractHolder.name")
		// Name of Insured Person
		const insuredName = get(policy, "contractInsured[0].name")
		// Array of Other Holders
		const otherHoldersArray = get(policy, "otherContractHolders", [])
		// Array of Primary Holder Name and Other Holders Names
		let allHolderNamesArray = [holderName]
		if (otherHoldersArray) {
			allHolderNamesArray.push(otherHoldersArray.map(item => item.name))
		}

		// Sum of Other holder(s) + Primary Holder
		const totalPolicyHolders =
			otherHoldersArray !== null ? otherHoldersArray.length + 1 : 0

		// Check whether one of Policy holders is Insured Person
		let noEqual = null
		allHolderNamesArray.filter(item => {
			if (insuredName !== item) noEqual = true
		})

		if (
			policy.status === "ISSUED" &&
			totalPolicyHolders === numberOfPolicyHolders &&
			noEqual === true
		) {
			return policy
		}
	}).length
}
